<template>
  <el-form-item label="选择套色" label-width="80">
    <el-dropdown trigger="click" @command="changeColor">
      <div class="pointer flex vcenter">
        <div v-if="props.prop.colorIndex === -1" style="display:inline-block;height: 28px;line-height: 28px" >请选择套色</div>
        <img v-if="props.prop.colorIndex == 0" style="height: 28px" src="@/assets/images/color0.png" />
        <img v-if="props.prop.colorIndex == 1" style="height: 28px" src="@/assets/images/color1.png" />
        <img v-if="props.prop.colorIndex == 2" style="height: 28px" src="@/assets/images/color2.png" />
        <img v-if="props.prop.colorIndex == 3" style="height: 28px" src="@/assets/images/color3.png" />
        <img v-if="props.prop.colorIndex == 4" style="height: 28px" src="@/assets/images/color4.png" />
        <img v-if="props.prop.colorIndex == 5" style="height: 28px" src="@/assets/images/color5.png" />
        <el-icon class="el-icon--right ml-4">
          <ArrowDown />
        </el-icon>
      </div>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item command="0">
            <img style="height: 28px" src="@/assets/images/color0.png" />
          </el-dropdown-item>
          <el-dropdown-item command="1">
            <img style="height: 28px" src="@/assets/images/color1.png" />
          </el-dropdown-item>
          <el-dropdown-item command="2">
            <img style="height: 28px" src="@/assets/images/color2.png" />
          </el-dropdown-item>
          <el-dropdown-item command="3">
            <img style="height: 28px" src="@/assets/images/color3.png" />
          </el-dropdown-item>
          <el-dropdown-item command="4">
            <img style="height: 28px" src="@/assets/images/color4.png" />
          </el-dropdown-item>
          <el-dropdown-item command="5">
            <img style="height: 28px" src="@/assets/images/color5.png" />
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </el-form-item>
  <colorTable v-model="prop.barColor"></colorTable>
</template>
<script setup>
import util from "@/option/common/util";
import {deepClone} from '@/echart/util'
import {ArrowDown} from "@element-plus/icons-vue";
import colorTable from './color-table.vue';
let props = defineProps({
	prop:{},
})
function changeColor(v) {
  props.prop.colorIndex = v
  let colors = util.getSetColors(v)
  props.prop.barColor = colors.map(el=>({color1:el}))

}
</script>
<style scoped>

</style>